module.exports = __webpack_public_path__ + "img/translate.24547224.svg";